import { render, staticRenderFns } from "./CBtnFollowIcon.vue?vue&type=template&id=bc815fa0"
import script from "./CBtnFollowIcon.vue?vue&type=script&lang=ts"
export * from "./CBtnFollowIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default})
